let _counter = 0;
class AdpTabsController {
  constructor($timeout) {
    this.name = 'adpTabs';
    this.$timeout = $timeout;
    this.id = ('adp-tabs-' + (_counter++)).toString();
    const _this = this;
    this.activeTab = 'tab-1';

    this.$timeout(() => {
      const $elem = $('#' + this.activeTab + '');
      this.indicator = $('#' + _this.id + ' .indicator');
      this.moveIndicator($elem);
    }, 50);
  }

  openTab(tabId) {
    this.activeTab = tabId;
  }
  itemMouseOver(tabId, index) {
    const $elem = $('#' + tabId + '');
    this.moveIndicator($elem);
  }
  itemMouseOut() {
    const $elem = $('#' + this.activeTab + '');
    this.moveIndicator($elem);
  }
  moveIndicator($elem) {
    const theOffset = $elem.position().left;
    const theWidth = $elem.outerWidth();
    this.indicator.css({'width': theWidth, 'transform': 'translateX('+ theOffset +'px)'}); 
  }
}

AdpTabsController.$inject = ['$timeout'];
export default AdpTabsController;





// WEBPACK FOOTER //
// ./src/app/components/adpTabs/adpTabs.controller.js